/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat A/B Testing — experiment list, builder and per-variant results viewer. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["ab-testing"] = "1.0.3"; } catch (e) {}
  function ic(n){ return (window.GSIcons&&GSIcons.svg)?(GSIcons.svg(n,16)+" "):""; }
  var root;
  function q(n){ return root?root.querySelector('[data-d="'+n+'"]'):null; }
  function qa(s){ return root?Array.prototype.slice.call(root.querySelectorAll(s)):[]; }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function val(el){ return el?el.value.trim():""; }
  function csv(s){ return String(s||"").split(",").map(function(x){return x.trim();}).filter(Boolean); }

  function ready(fn){ var done=false; function go(){ if(done)return; done=true; fn(); }
    document.addEventListener("gs:ready",go,{once:true});
    var n=0,t=setInterval(function(){ if(window.GS&&GS.api&&GS.site){clearInterval(t);go();} else if(++n>200)clearInterval(t); },30);
    if(window.GS&&GS.api&&GS.site)go(); }

  var LIST=[];

  /* ---------------- list ---------------- */
  function statusBadge(s){ var m={draft:"s-draft",running:"s-run",paused:"s-pause",completed:"s-done"}; return '<span class="ab-status '+(m[s]||"")+'">'+esc(s)+'</span>'; }
  function loadList(){
    GS.api("/plugin/ab-testing/list?site="+encodeURIComponent(GS.site)).then(function(r){
      LIST=(r.ok&&r.data&&r.data.experiments)||[]; renderList();
    });
  }
  function renderList(){
    var tb=q("tbody");
    function abRow(x){
      var up=(x.best_uplift==null)?"\u2014":((x.best_uplift>=0?"+":"")+x.best_uplift+"%");
      return '<tr data-row="'+x.id+'"><td class="xn">'+ic("ab-testing")+esc(x.name)+"</td>"+
        "<td>"+statusBadge(x.status)+"</td>"+
        '<td class="r">'+(x.variant_count||0)+"</td>"+
        '<td class="r '+((x.best_uplift||0)>=0?"pos":"neg")+'">'+up+"</td>"+
        "<td>"+(x.winner?('<span class="ab-win">'+ic("check")+esc(x.winner)+"</span>"):'<span class="gs-muted">\u2014</span>')+"</td>"+
        '<td class="r nowrap"><button class="ab-mini" data-edit="'+x.id+'"><i class="bi bi-pencil"></i></button> <button class="ab-mini danger" data-del="'+x.id+'"><i class="bi bi-trash"></i></button></td></tr>';
    }
    if (window.GSMore) GSMore.mount({ container:tb, table:true, colspan:6, items:LIST, pageSize:20, emptyText:TR('abtest.f3.no_experiments_yet_click_u201cnew_'), render:abRow });
    else tb.innerHTML = LIST.length ? LIST.map(abRow).join("") : '<tr><td colspan="6" class="empty">'+TR('abtest.f2.no_experiments_yet')+'</td></tr>';
    // One delegated listener for rows plus their edit/delete buttons.
    if(!tb._abDel){ tb._abDel=1; tb.addEventListener("click",function(e){
      var ed=e.target.closest&&e.target.closest("[data-edit]"); if(ed){ editExp(+ed.getAttribute("data-edit")); return; }
      var dl=e.target.closest&&e.target.closest("[data-del]");  if(dl){ delExp(+dl.getAttribute("data-del")); return; }
      var tr=e.target.closest&&e.target.closest("tr[data-row]"); if(tr) openViewer(+tr.getAttribute("data-row")); }); }
  }

  /* ---------------- viewer ---------------- */
  function openViewer(id){
    if (window.GSLink) window.GSLink.write({ id: id });   // the open view becomes linkable
    GS.api("/plugin/ab-testing/stats?site="+encodeURIComponent(GS.site)+"&experiment="+id+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){
      if(!r.ok||!r.data||!r.data.available){ return; }
      renderViewer(r.data);
    });
  }
  function renderViewer(d){
    var v=q("viewer"); v.hidden=false;
    q("viewer-title").textContent=(d.experiment&&d.experiment.name)||"Experiment";
    q("viewer-winner").innerHTML=d.winner?('<span class="ab-win">'+ic("check")+"Winner: "+esc(d.winner)+"</span>"):'<span class="gs-muted small">'+TT('abte.js.no_significant_winner_yet')+'</span>';
    var max=1; (d.variants||[]).forEach(function(x){ if(x.conv_rate>max)max=x.conv_rate; });
    q("variants-view").innerHTML=(d.variants||[]).map(function(x){
      var sig = x.is_control ? '<span class="gs-muted small">baseline</span>'
        : (x.significant?('<span class="ab-sig ok">'+x.confidence+'% conf</span>'):('<span class="ab-sig no">not significant</span>'));
      var upl = x.is_control ? "" : '<span class="ab-upl '+(x.uplift>=0?"pos":"neg")+'">'+(x.uplift>=0?"+":"")+x.uplift+'%</span>';
      return '<div class="ab-vv '+(x.is_control?"ctrl":"")+(d.winner===x.name?" winrow":"")+'">'+
        '<div class="ab-vv-head"><span class="ab-vv-name">'+esc(x.name)+(x.is_control?' <span class="ab-tag">'+TR('abtest.g.control')+'</span>':"")+"</span>"+upl+"</div>"+
        '<div class="ab-vv-bar"><i style="width:'+Math.max(2,(x.conv_rate/max*100))+'%"></i><b>'+x.conv_rate+'%</b></div>'+
        '<div class="ab-vv-meta"><span>'+x.visitors.toLocaleString()+" visitors</span><span>"+x.conversions.toLocaleString()+" conversions</span>"+sig+"</div></div>";
    }).join("") || '<div class="empty">'+TR('abtest.g.no_data_in_this_range')+'</div>';
    v.scrollIntoView({behavior:"smooth",block:"nearest"});
  }

  /* ---------------- builder ---------------- */
  function bf(k){ return root.querySelector('[data-bf="'+k+'"]'); }
  function openBuilder(exp){
    q("builder").hidden=false; q("viewer").hidden=true;
    q("builder-title").textContent=exp?("Edit \u2014 "+exp.name):TR('abtest.g.new_experiment');
    bf("id").value=exp?exp.id:"";
    ["name","description","goal_type","goal_value","status"].forEach(function(k){ bf(k).value=exp?(exp[k]||""):(k==="goal_type"?"event":(k==="status"?"draft":"")); });
    var tg=(exp&&exp.targeting)||{};
    bf("t_url").value=tg.url||""; bf("t_devices").value=(tg.devices||[]).join(", "); bf("t_countries").value=(tg.countries||[]).join(", ");
    var host=q("variants"); host.innerHTML="";
    var vs=(exp&&exp.variants&&exp.variants.length)?exp.variants:[{name:TR('abtest.g.control'),weight:50,is_control:1,changes:{}},{name:"Variant B",weight:50,changes:{}}];
    vs.forEach(addVariant); updateWeights();
    q("builder").scrollIntoView({behavior:"smooth",block:"start"});
  }
  function addVariant(data){
    data=data||{name:"",weight:0,changes:{}};
    var tpl=document.getElementById("ab-variant-tpl"); if(!tpl)return;
    var node=tpl.content.firstElementChild.cloneNode(true);
    node.querySelector('[data-vf="name"]').value=data.name||"";
    node.querySelector('[data-vf="is_control"]').checked=!!data.is_control;
    var rng=node.querySelector('[data-vf="weight"]'); rng.value=data.weight||0;
    node.querySelector('[data-vf="weightlabel"]').textContent=(data.weight||0)+"%";
    var ch=data.changes||{}; node.querySelector('[data-vf="redirect"]').value=ch.redirect||"";
    node.querySelector('[data-vf="css"]').value=ch.css||""; node.querySelector('[data-vf="js"]').value=ch.js||"";
    rng.addEventListener("input",function(){ node.querySelector('[data-vf="weightlabel"]').textContent=rng.value+"%"; updateWeights(); });
    node.querySelector("[data-vdel]").addEventListener("click",function(){ node.remove(); updateWeights(); });
    q("variants").appendChild(node);
  }
  function updateWeights(){
    var tot=0; qa("[data-vrow]").forEach(function(r){ tot+=(+r.querySelector('[data-vf="weight"]').value||0); });
    var el=q("weight-total"); if(el){ el.textContent="total "+tot+"%"; el.className="ab-wtot"+(tot===100?" ok":" warn"); }
  }
  function collect(){
    var variants=qa("[data-vrow]").map(function(r){
      return { name:val(r.querySelector('[data-vf="name"]')), weight:+r.querySelector('[data-vf="weight"]').value||0,
        is_control:r.querySelector('[data-vf="is_control"]').checked,
        changes:{ redirect:val(r.querySelector('[data-vf="redirect"]')), css:val(r.querySelector('[data-vf="css"]')), js:val(r.querySelector('[data-vf="js"]')) } };
    });
    return { id:bf("id").value?+bf("id").value:0, name:val(bf("name")), description:val(bf("description")),
      goal_type:bf("goal_type").value, goal_value:val(bf("goal_value")), status:bf("status").value,
      targeting:{ url:val(bf("t_url")), devices:csv(bf("t_devices").value), countries:csv(bf("t_countries").value) }, variants:variants };
  }
  function saveBuilder(){
    var p=collect(); if(!p.name){ q("builder-status").textContent=TT('ab.a.name_required'); return; }
    var st=q("builder-status"); st.textContent=TT('ab.a.saving_u2026');
    var url="/plugin/ab-testing/"+(p.id?"update":"create")+"?site="+encodeURIComponent(GS.site);
    GS.api(url,{method:"POST",body:JSON.stringify(p)}).then(function(r){
      if(r.ok&&r.data&&(r.data.ok||r.data.id)){ st.textContent=TT('ab.a.saved_u2713'); q("builder").hidden=true; loadList(); }
      else st.textContent=TT('ab.a.error');
    });
  }
  function editExp(id){ GS.api("/plugin/ab-testing/get?site="+encodeURIComponent(GS.site)+"&id="+id).then(function(r){ if(r.ok&&r.data&&r.data.id) openBuilder(r.data); }); }
  function delExp(id){ var x=LIST.filter(function(e){return e.id===id;})[0];
    if(!confirm(TT('ab.x.delete_experiment')+' '+(x?('"'+x.name+'"'):"#"+id)+"? This removes its variants."))return;
    GS.api("/plugin/ab-testing/delete?site="+encodeURIComponent(GS.site),{method:"POST",body:JSON.stringify({id:id})}).then(function(){ q("viewer").hidden=true; loadList(); }); }

  /* ---------------- range ---------------- */
  function _ymd(d){ return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2); }
  function _today(){ var t=new Date(); return new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days){ var to=_today(),from=new Date(to.getTime()-(days-1)*86400000); var lbl={7:T("an.last7"),30:T("an.last30"),90:T("an.last90")}[days]||T("an.lastndays",{n:days}); return {from:_ymd(from),to:_ymd(to),label:lbl,preset:String(days)}; }
  var RANGE=(function(){ try{ var s=JSON.parse(localStorage.getItem("gs_ab_range")||"null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if(s&&s.from)return s; }catch(e){} return preset(30); })();
  function initRange(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label"); if(!btn)return;
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    btn.addEventListener("click",function(e){ if(menu.contains(e.target)&&e.target!==btn)return; e.stopPropagation(); menu.style.display=menu.style.display==="none"?"block":"none"; });
    document.addEventListener("click",function(){ menu.style.display="none"; });
    menu.addEventListener("click",function(e){ e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){ b.addEventListener("click",function(){ RANGE=preset(+b.getAttribute("data-preset")); if(lab)lab.textContent=RANGE.label; try{localStorage.setItem("gs_ab_range",JSON.stringify(RANGE));}catch(e){} menu.style.display="none"; if(!q("viewer").hidden){} loadList(); }); });
    var _ap=menu.querySelector('[data-rp="apply"]');if(_ap)_ap.addEventListener("click",function(){var ff=(menu.querySelector('[data-rp="from"]')||{}).value,tt=(menu.querySelector('[data-rp="to"]')||{}).value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}RANGE={from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null};if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_ab-testing_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";load();});
    btn.addEventListener("click",function(){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf&&RANGE.from)cf.value=RANGE.from;if(ct&&RANGE.to)ct.value=RANGE.to;});
  }

  function init(){
    root=document.querySelector('[data-d="root"]'); if(!root)return;
    q("new-exp").addEventListener("click",function(){ openBuilder(null); });
    q("add-variant").addEventListener("click",function(){ addVariant({name:"Variant "+String.fromCharCode(65+qa("[data-vrow]").length),weight:0}); updateWeights(); });
    q("builder-save").addEventListener("click",saveBuilder);
    q("builder-cancel").addEventListener("click",function(){ q("builder").hidden=true; });
    q("builder-close").addEventListener("click",function(){ q("builder").hidden=true; });
    initRange(); loadList();
  }
  /* Deep link: /ab-testing?id=<v> opens that view directly, so it can be linked from an email,
     a dashboard widget or another report. The spelling lives in GSLink so no two pages can
     disagree about it. The inline fallback covers the window before gs-deeplink.js is deployed —
     it must ASSIGN, not return: an early return exits gsDeep() and the opener never fires.
     Anything malformed is ignored and the normal list loads. */
  function gsDeep() {
    var v = null;
    if (window.GSLink) {
      v = window.GSLink.read({ id: "int" }).id;
    } else {
      try {
        var p = new URLSearchParams(location.search);
        var _n = parseInt(String(p.get("id") || "").replace(/[^0-9-]/g, ""), 10);
        v = isNaN(_n) ? null : _n;
      } catch (e) { v = null; }
    }
    if (v !== null && v !== "") openViewer(v);
  }
  ready(function () { init(); gsDeep(); });
})();
